import React from 'react';
export interface Article {
  slug: string;
  title: string;
  content: React.ReactNode;
  categorySlug: string;
  categoryName: string;
}
export const categories = [{
  slug: 'preguntas-frecuentes',
  name: 'Preguntas Frecuentes'
}, {
  slug: 'compras-recurrentes',
  name: 'Compras Recurrentes'
}, {
  slug: 'promociones-y-descuentos',
  name: 'Promociones y descuentos'
}, {
  slug: 'pagos-y-facturas',
  name: 'Pagos y Facturas'
}];
export const articles: Article[] = [
// Preguntas Frecuentes
{
  slug: 'como-puedo-generar-un-pedido-en-vitau',
  title: '¿Cómo puedo generar un pedido en Vitau?',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-155">
        <p data-id="element-156">
          ¡Puedes generar un pedido desde nuestra tienda en línea con tan solo
          un par de clicks!
        </p>
        <p data-id="element-157">
          También puedes hacerlo a través de nuestra App disponible para
          dispositivos IOS y Android.
        </p>
        <div className="bg-[#e6f7f9] p-6 rounded-lg mt-6" data-id="element-158">
          <p className="mb-4" data-id="element-159">
            Recuerda que puedes descargar nuestra App desde:
          </p>
          <ul className="space-y-2" data-id="element-160">
            <li data-id="element-161">
              <a href="#" className="text-[#0af] font-bold hover:underline" data-id="element-162">
                Google Play Store
              </a>
            </li>
            <li data-id="element-163">
              <a href="#" className="text-[#0af] font-bold hover:underline" data-id="element-164">
                Apple App Store
              </a>
            </li>
          </ul>
        </div>
        <p className="mt-6" data-id="element-165">
          Generar un pedido en Vitau es muy sencillo. Puedes hacerlo de tres
          formas:
        </p>
        <ol className="list-decimal pl-5 space-y-2 mt-4" data-id="element-166">
          <li data-id="element-167">
            <strong data-id="element-168">A través de nuestra App:</strong> Descarga la app Vitau,
            busca tus medicamentos, agrégalos al carrito y sigue los pasos de
            pago.
          </li>
          <li data-id="element-169">
            <strong data-id="element-170">Por WhatsApp:</strong> Envíanos tu receta al número de
            atención y un asesor te ayudará a armar tu pedido.
          </li>
          <li data-id="element-171">
            <strong data-id="element-172">En el sitio web:</strong> Navega por nuestro catálogo en
            vitau.mx y realiza tu compra en línea.
          </li>
        </ol>
      </div>
}, {
  slug: 'horarios-atencion',
  title: '¿Cuáles son sus horarios de atención?',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-173">
        <p data-id="element-174">
          Nuestro equipo de atención a clientes está disponible de Lunes a
          Viernes de 8:00 AM a 8:00 PM, y Sábados de 9:00 AM a 2:00 PM.
        </p>
        <p data-id="element-175">
          Los pedidos en línea a través de nuestra página web o aplicación móvil
          pueden realizarse las 24 horas del día, los 365 días del año.
        </p>
      </div>
}, {
  slug: 'tienen-envios-a-todo-el-territorio-nacional',
  title: '¿Tienen envíos a todo el territorio nacional?',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-176">
        <p data-id="element-177">
          Sí, realizamos envíos a todo México. Contamos con cobertura extendida
          gracias a nuestros aliados logísticos para asegurar que tus
          medicamentos lleguen a donde estés.
        </p>
        <p data-id="element-178">
          Para zonas extendidas o de difícil acceso, el tiempo de entrega podría
          variar ligeramente, pero siempre te mantendremos informado sobre el
          estatus de tu pedido.
        </p>
      </div>
}, {
  slug: 'tiempos-de-entrega',
  title: 'Tiempos de Entrega',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-179">
        <p data-id="element-180">
          En Vitau nos preocupamos por la salud de nuestros pacientes, por lo
          que ofrecemos entregas locales y nacionales hasta la puerta de tu
          casa.
        </p>
        <p className="font-bold" data-id="element-181">
          Contamos con dos modalidades de envíos: Locales y nacionales.
          Enseguida te comentamos a detalle sobre los tiempos estimados de
          entrega de ambos.
        </p>

        <h3 className="text-xl font-bold text-[#022a3b] mt-6 mb-2" data-id="element-182">
          Envíos Locales
        </h3>
        <p data-id="element-183">
          El tiempo estimado de entrega para las ordenes locales es de uno a dos
          días hábiles en un horario que va desde las 12:00pm a las 8:00pm. Te
          invitamos a llenar la información de envío en tu carrito de compras
          para poder conocer el día de entrega estimado para tu pedido.
        </p>

        <h3 className="text-xl font-bold text-[#022a3b] mt-6 mb-2" data-id="element-184">
          Envíos Nacionales
        </h3>
        <p data-id="element-185">
          Para el resto del país, el tiempo promedio es de 24 a 48 horas
          hábiles, dependiendo de tu ubicación y la accesibilidad de la zona.
        </p>
      </div>
}, {
  slug: 'cual-es-el-costo-de-envio-de-mi-pedido',
  title: '¿Cuál es el costo de envío de mi pedido?',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-186">
        <p data-id="element-187">El envío es GRATIS en pedidos mayores a $499 MXN.</p>
        <p data-id="element-188">Para pedidos menores a este monto, el costo es de:</p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-189">
          <li data-id="element-190">$59 MXN en CDMX y Área Metropolitana</li>
          <li data-id="element-191">$99 MXN para el resto de la república mexicana</li>
        </ul>
      </div>
}, {
  slug: 'se-aceptan-devoluciones',
  title: '¿Se aceptan devoluciones?',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-192">
        <p data-id="element-193">
          Por regulación sanitaria y para garantizar la seguridad de todos
          nuestros pacientes,{' '}
          <strong data-id="element-194">no podemos aceptar devoluciones de medicamentos</strong> una
          vez que han sido entregados.
        </p>
        <p data-id="element-195">Las únicas excepciones a esta regla son:</p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-196">
          <li data-id="element-197">
            Si hubo un error en el surtido por parte de nuestra farmacia
            (recibiste un medicamento distinto al recetado).
          </li>
          <li data-id="element-198">
            Si el producto presenta defectos de fábrica evidentes o caducidad
            vencida al momento de la entrega.
          </li>
        </ul>
        <p data-id="element-199">
          Si te encuentras en alguna de estas situaciones, por favor contáctanos
          inmediatamente a través de nuestros canales de atención para procesar
          el cambio o reembolso correspondiente.
        </p>
      </div>
}, {
  slug: 'puedo-solicitar-apoyo-para-hacer-los-tramites-de-mi-seguro',
  title: '¿Puedo solicitar apoyo para hacer los trámites de mi seguro?',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-200">
        <p data-id="element-201">
          Sí, emitimos facturas que cumplen con todos los requisitos fiscales
          (CFDI 4.0) para que puedas tramitar tu reembolso con aseguradoras de
          gastos médicos mayores.
        </p>
        <p data-id="element-202">
          Además, si tu aseguradora requiere algún desglose específico o formato
          particular, nuestro equipo de atención a clientes puede orientarte
          sobre cómo obtener la documentación necesaria de tus compras en Vitau.
        </p>
      </div>
}, {
  slug: 'no-encontre-disponible-el-medicamento',
  title: 'No encontré disponible el medicamento que estoy buscando ¿Cómo puedo saber si es posible conseguirlo?',
  categorySlug: 'preguntas-frecuentes',
  categoryName: 'Preguntas Frecuentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-203">
        <p data-id="element-204">
          Si no encuentras lo que buscas en nuestro catálogo en línea, ¡no te
          preocupes!
        </p>
        <p data-id="element-205">
          Contáctanos por WhatsApp al <strong data-id="element-206">(81) 4800 7977</strong>. Tenemos
          una red amplia de proveedores y distribuidores autorizados, y nuestro
          equipo de farmacéuticos hará todo lo posible por conseguir el
          medicamento especial que necesitas.
        </p>
      </div>
},
// Compras Recurrentes
{
  slug: 'recordatorios-en-nuestra-app-una-nueva-herramienta-para-cuidar-de-tu-salud',
  title: 'Recordatorios en nuestra App: Una nueva herramienta para cuidar de tu salud',
  categorySlug: 'compras-recurrentes',
  categoryName: 'Compras Recurrentes',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-207">
        <p data-id="element-208">
          Te invitamos a conocer ésta herramienta en nuestra App que te
          permitirá programar recordatorios para llevar un mejor control de tu
          tratamiento y hacer que tus compras sean más sencillas.
        </p>

        <h3 className="text-xl font-bold text-[#022a3b] mt-8 mb-4" data-id="element-209">
          ¿Sabes qué es la adherencia al tratamiento?
        </h3>
        <p data-id="element-210">
          La adherencia al tratamiento es el grado en el cual una persona sigue
          las prescripciones farmacológicas. Se estima que sólo el 50% de las
          personas que salen de consulta médica con una receta, tomarán el
          fármaco según las indicaciones recibidas.
        </p>
        <p data-id="element-211">
          La falta de adherencia puede tener consecuencias graves para la salud,
          incluyendo el empeoramiento de la enfermedad, complicaciones y un
          aumento en los costos de atención médica.
        </p>

        <h3 className="text-xl font-bold text-[#022a3b] mt-8 mb-4" data-id="element-212">
          ¿Cómo funcionan los recordatorios de Vitau?
        </h3>
        <p data-id="element-213">Nuestra nueva funcionalidad te permite:</p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-214">
          <li data-id="element-215">Configurar alarmas diarias para la toma de tus medicamentos.</li>
          <li data-id="element-216">
            Recibir notificaciones cuando estés a punto de quedarte sin
            medicina.
          </li>
          <li data-id="element-217">
            Aprobar la recompra de tu tratamiento con un solo clic desde la
            notificación.
          </li>
        </ul>
        <p className="mt-6" data-id="element-218">
          Descarga la App de Vitau hoy mismo y toma el control de tu salud.
        </p>
      </div>
},
// Promociones y descuentos
{
  slug: 'guia-como-aplico-un-cupon-de-descuento-a-mi-orden',
  title: 'Guía: ¿Cómo aplico un cupón de descuento a mi orden?',
  categorySlug: 'promociones-y-descuentos',
  categoryName: 'Promociones y descuentos',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-219">
        <p data-id="element-220">Aplicar un cupón en Vitau es muy fácil. Sigue estos pasos:</p>
        <ol className="list-decimal pl-5 space-y-4 mt-4" data-id="element-221">
          <li data-id="element-222">
            Agrega los medicamentos o productos que deseas a tu carrito de
            compras.
          </li>
          <li data-id="element-223">
            Ve a tu carrito haciendo clic en el ícono en la esquina superior
            derecha.
          </li>
          <li data-id="element-224">
            En el resumen de tu orden, busca el campo que dice{' '}
            <strong data-id="element-225">"Código de descuento"</strong> o <strong data-id="element-226">"Cupón"</strong>.
          </li>
          <li data-id="element-227">
            Ingresa el código exactamente como lo recibiste (respetando
            mayúsculas y minúsculas).
          </li>
          <li data-id="element-228">
            Haz clic en el botón <strong data-id="element-229">"Aplicar"</strong>.
          </li>
          <li data-id="element-230">
            Verás que el total de tu orden se actualiza automáticamente
            reflejando el descuento.
          </li>
        </ol>
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-6" data-id="element-231">
          <p className="text-sm text-yellow-800" data-id="element-232">
            <strong data-id="element-233">Nota:</strong> Si el cupón no funciona, verifica que cumpla
            con los términos y condiciones (monto mínimo, vigencia, productos
            participantes).
          </p>
        </div>
      </div>
}, {
  slug: 'programas-de-lealtad-vigencias-y-restricciones',
  title: 'Programas de lealtad: Vigencias y restricciones',
  categorySlug: 'promociones-y-descuentos',
  categoryName: 'Promociones y descuentos',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-234">
        <p data-id="element-235">
          En Vitau manejamos programas de lealtad de diversos laboratorios (como
          Pfizer, AstraZeneca, Novartis, entre otros) para ayudarte a mantener
          tu tratamiento a un menor costo.
        </p>

        <h3 className="text-xl font-bold text-[#022a3b] mt-6 mb-2" data-id="element-236">
          ¿Cómo inscribirme?
        </h3>
        <p data-id="element-237">
          Para inscribirte a un programa de lealtad, generalmente necesitaremos
          algunos datos de tu receta médica y tu información básica. Contáctanos
          por WhatsApp para verificar si tu medicamento participa en algún
          programa y te ayudaremos con el registro.
        </p>

        <h3 className="text-xl font-bold text-[#022a3b] mt-6 mb-2" data-id="element-238">
          Restricciones comunes
        </h3>
        <ul className="list-disc pl-5 space-y-2" data-id="element-239">
          <li data-id="element-240">
            Los beneficios (como piezas gratis por acumulación de compras) están
            sujetos a las políticas dictadas directamente por cada laboratorio.
          </li>
          <li data-id="element-241">
            Las compras deben realizarse dentro de los periodos de vigencia
            establecidos por el laboratorio.
          </li>
          <li data-id="element-242">
            Por lo general, los beneficios de programas de lealtad no son
            acumulables con otros cupones o descuentos de Vitau.
          </li>
        </ul>
      </div>
}, {
  slug: 'terminos-y-condiciones-generales-de-promociones-vitau',
  title: 'Términos y condiciones generales de promociones Vitau',
  categorySlug: 'promociones-y-descuentos',
  categoryName: 'Promociones y descuentos',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-243">
        <p data-id="element-244">
          A menos que se especifique lo contrario en la comunicación de una
          promoción específica, aplican los siguientes términos generales:
        </p>
        <ul className="list-disc pl-5 space-y-3 mt-4" data-id="element-245">
          <li data-id="element-246">
            <strong data-id="element-247">No acumulables:</strong> Los cupones de descuento no son
            acumulables con otras ofertas, promociones o descuentos ya aplicados
            al producto.
          </li>
          <li data-id="element-248">
            <strong data-id="element-249">Un uso por usuario:</strong> Los cupones de bienvenida o
            primera compra están limitados a un solo uso por
            cliente/cuenta/domicilio.
          </li>
          <li data-id="element-250">
            <strong data-id="element-251">Vigencia:</strong> Todas nuestras promociones tienen fecha
            de caducidad. Una vez expirada la fecha, el sistema no aceptará el
            código.
          </li>
          <li data-id="element-252">
            <strong data-id="element-253">Exclusiones:</strong> Algunos medicamentos de alta
            especialidad, controlados o con margen regulado pueden estar
            excluidos de promociones generales.
          </li>
          <li data-id="element-254">
            <strong data-id="element-255">Modificaciones:</strong> Vitau se reserva el derecho de
            modificar o cancelar cualquier promoción en caso de detectar uso
            fraudulento o abuso del sistema.
          </li>
        </ul>
      </div>
},
// Pagos y Facturas
{
  slug: 'como-puedo-pedir-la-factura-de-mi-pedido',
  title: '¿Cómo puedo pedir la factura de mi pedido?',
  categorySlug: 'pagos-y-facturas',
  categoryName: 'Pagos y Facturas',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-256">
        <p data-id="element-257">
          Para solicitar tu factura, sigue estos sencillos pasos desde nuestro
          portal:
        </p>
        <ol className="list-decimal pl-5 space-y-3 mt-4" data-id="element-258">
          <li data-id="element-259">Ingresa a tu cuenta en vitau.mx con tu correo y contraseña.</li>
          <li data-id="element-260">
            Dirígete a la sección <strong data-id="element-261">"Mis Pedidos"</strong>.
          </li>
          <li data-id="element-262">Selecciona el pedido que deseas facturar.</li>
          <li data-id="element-263">
            Haz clic en el botón <strong data-id="element-264">"Solicitar Factura"</strong>.
          </li>
          <li data-id="element-265">
            Ingresa o confirma tus datos fiscales (RFC, Razón Social, Uso de
            CFDI, Régimen Fiscal y Código Postal).
          </li>
          <li data-id="element-266">
            Haz clic en <strong data-id="element-267">"Generar"</strong>. Recibirás los archivos PDF y
            XML en tu correo electrónico registrado.
          </li>
        </ol>
        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mt-6" data-id="element-268">
          <p className="text-sm text-blue-800" data-id="element-269">
            <strong data-id="element-270">Importante:</strong> Tienes hasta el último día del mes en
            curso en el que realizaste tu compra para solicitar tu factura. Por
            disposiciones fiscales, no podemos emitir facturas de meses
            anteriores.
          </p>
        </div>
      </div>
}, {
  slug: 'que-metodos-de-pago-se-aceptan',
  title: '¿Qué métodos de pago se aceptan?',
  categorySlug: 'pagos-y-facturas',
  categoryName: 'Pagos y Facturas',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-271">
        <p data-id="element-272">
          En Vitau ofrecemos múltiples opciones para que pagues de la forma que
          te resulte más cómoda y segura:
        </p>
        <ul className="list-disc pl-5 space-y-3 mt-4" data-id="element-273">
          <li data-id="element-274">
            <strong data-id="element-275">Tarjetas de Crédito y Débito:</strong> Aceptamos Visa,
            Mastercard y American Express.
          </li>
          <li data-id="element-276">
            <strong data-id="element-277">PayPal:</strong> Puedes pagar usando tu cuenta de PayPal.
          </li>
          <li data-id="element-278">
            <strong data-id="element-279">Transferencia Bancaria (SPEI):</strong> Te proporcionaremos
            una CLABE interbancaria única para tu pedido.
          </li>
          <li data-id="element-280">
            <strong data-id="element-281">Pago en Efectivo:</strong> Puedes generar una referencia
            para pagar en tiendas OXXO, 7-Eleven, Farmacias del Ahorro, entre
            otros establecimientos afiliados a OpenPay.
          </li>
        </ul>
        <p className="mt-4" data-id="element-282">
          Todas nuestras transacciones con tarjeta son procesadas a través de
          pasarelas de pago certificadas con los más altos estándares de
          seguridad (PCI DSS). Vitau no almacena los datos de tu tarjeta.
        </p>
      </div>
}, {
  slug: 'mi-intento-de-pago-fue-rechazado-que-puedo-hacer',
  title: 'Mi intento de pago fue rechazado ¿Qué puedo hacer?',
  categorySlug: 'pagos-y-facturas',
  categoryName: 'Pagos y Facturas',
  content: <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-283">
        <p data-id="element-284">
          Si tu pago con tarjeta fue rechazado, te recomendamos intentar lo
          siguiente:
        </p>
        <ul className="list-disc pl-5 space-y-3 mt-4" data-id="element-285">
          <li data-id="element-286">
            <strong data-id="element-287">Verifica tus datos:</strong> Asegúrate de que el número de
            tarjeta, fecha de expiración y código CVV sean correctos.
          </li>
          <li data-id="element-288">
            <strong data-id="element-289">Fondos suficientes:</strong> Confirma que cuentas con saldo
            o límite de crédito disponible.
          </li>
          <li data-id="element-290">
            <strong data-id="element-291">Bloqueo de seguridad:</strong> En ocasiones, los bancos
            bloquean compras en línea por seguridad, especialmente si es tu
            primera compra en Vitau. Contacta a tu banco para autorizar el
            cargo.
          </li>
          <li data-id="element-292">
            <strong data-id="element-293">Intenta otro método:</strong> Si el problema persiste,
            puedes intentar con otra tarjeta, usar PayPal, o seleccionar pago
            por transferencia (SPEI) o efectivo.
          </li>
        </ul>
        <p className="mt-4" data-id="element-294">
          Si necesitas ayuda para completar tu compra, no dudes en contactarnos
          por WhatsApp y un asesor te guiará.
        </p>
      </div>
}];